import * as i0 from "@angular/core";
export class ParentDetailHomeStore {
}
ParentDetailHomeStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ParentDetailHomeStore_Factory() { return new ParentDetailHomeStore(); }, token: ParentDetailHomeStore, providedIn: "root" });
export var ParentDetailHomeStoreKeys;
(function (ParentDetailHomeStoreKeys) {
})(ParentDetailHomeStoreKeys || (ParentDetailHomeStoreKeys = {}));
